import { Clickable, Icon, Row, Text } from 'components';
import { theme } from 'lib';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

const ErrWrap = styled.div`
  position: fixed;
  width: 560px;
  top: 30px;
  right: ${(props) => (props.visible ? '30px' : '-610px')};
  transition: right 0.3s;
  background: ${(props) => (props.isErr ? theme.SECONDARY : '#000000')};
  border: ${(props) => (props.isErr ? 'none' : '1px solid #ffffff')};
  padding: 25px;
  z-index: 10000;
  border-radius: 4px;

  @media (max-width: 1024px) {
    width: 80vw;
    padding: 16px;
    right: ${(props) => (props.visible ? '30px' : '-100vw')};
  }
`;

let timer;
const ErrRes = () => {
  const [visible, setVisible] = useState(false),
    [lastErrRes, setLastErrRes] = useState(''),
    errRes = useSelector((state) => state?.appState?.errRes) || {},
    { err = '', res = '' } = errRes,
    dispatch = useDispatch();

  useEffect(() => {
    show();

    dispatch({
      type: 'HANDLE_RES',
      payload: { err: '' }
    });
  }, []);

  useEffect(() => {
    if (lastErrRes === errRes || (!err && !res)) return;

    show();
  }, [errRes]);

  function show() {
    clearTimeout(timer);

    setVisible(true);
    setLastErrRes(err || res);

    timer = setTimeout(() => {
      hide();
    }, 6000);
  }

  function hide() {
    clearTimeout(timer);

    setVisible(false);
    setLastErrRes('');

    timer = setTimeout(() => {
      dispatch({
        type: 'HANDLE_RES',
        payload: {}
      });
    }, 1000);
  }

  return (
    <React.Fragment>
      <ErrWrap visible={visible && errRes.err} isErr>
        <Row between center>
          <Row>
            <Text marg="0 0 0 15px" col="white">
              {typeof errRes.err === 'string' && errRes.err}
            </Text>
          </Row>

          <Clickable onClick={hide}>
            <Icon type="close" dimensions={13} />
          </Clickable>
        </Row>
      </ErrWrap>

      <ErrWrap visible={visible && errRes.res}>
        <Row between center>
          <Row>
            <Text marg="0 0 0 15px" col="white" med>
              {typeof errRes.res === 'string' && errRes.res}
            </Text>
          </Row>

          <Clickable onClick={hide}>
            <Icon type="close" dimensions={13} />
          </Clickable>
        </Row>
      </ErrWrap>
    </React.Fragment>
  );
};

export default ErrRes;
